import { IMessageAttachment } from '../interfaces/message-attachment.interface';
import { IMessageChart } from '../interfaces/message-chart.interface';
import {
  IUserAttachment,
  IUserAttachmentRaw,
  toUserAttachment
} from '../interfaces/user-attachment.interface';

const record = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown> : null;

const isAccessMode = (value: unknown): value is 'proxy' | 'signed' =>
  value === 'proxy' || value === 'signed';

const normalizeUserAttachment = (
  raw: Record<string, unknown>
): IUserAttachment | null => {
  if (
    typeof raw.attachment_id !== 'string' || !raw.attachment_id ||
    typeof raw.name !== 'string' || typeof raw.mime !== 'string' ||
    typeof raw.size_bytes !== 'number' || typeof raw.status !== 'string' ||
    !isAccessMode(raw.access_mode)
  ) {
    return null;
  }
  return toUserAttachment(raw as unknown as IUserAttachmentRaw);
};

const normalizeAgentAttachment = (
  raw: Record<string, unknown>
): IMessageAttachment | null => {
  if (
    typeof raw.file_id !== 'string' || !raw.file_id ||
    typeof raw.object_path !== 'string' || typeof raw.name !== 'string' ||
    typeof raw.mime !== 'string' || !isAccessMode(raw.access_mode)
  ) {
    return null;
  }
  return {
    source: 'agent',
    fileId: raw.file_id,
    objectPath: raw.object_path,
    name: raw.name,
    mime: raw.mime,
    accessMode: raw.access_mode,
    ...(typeof raw.url === 'string' && { url: raw.url }),
    ...(typeof raw.attachment_id === 'string' &&
      raw.attachment_id !== '' && { attachmentId: raw.attachment_id })
  };
};

/** A mesma normalização serve ao stream e ao histórico, que trazem formatos distintos. */
export const normalizeAttachment = (value: unknown): IMessageAttachment | null => {
  const raw = record(value);
  if (!raw) {
    return null;
  }
  return 'file_id' in raw
    ? normalizeAgentAttachment(raw)
    : normalizeUserAttachment(raw);
};

export const normalizeChart = (value: unknown): IMessageChart | null => {
  const content = record(value);
  if (!content) {
    return null;
  }
  const spec = 'spec' in content ? record(content.spec) : content;
  if (!spec) {
    return null;
  }
  const options = 'options' in spec ? record(spec.options) : spec;
  if (!options) {
    return null;
  }
  return {
    ...(typeof spec.title === 'string' && { title: spec.title }),
    options
  };
};
